<template>
    <transition name="myuidialog">
        <div v-if="visible" class="com-codics-ui-mydialog-xxbb-body" :style="{ '--width': width, '--height': height }"
            @click="(e) => out && changeShow(e)">
            <div class="com-codics-ui-mydialog-xxbb-body-card" @click.stop="1">
                <div class="com-codics-ui-mydialog-xxbb-body-header">
                    <span class="iconfonts" style="font-size: 12px;" v-html="title"></span>
                    <div class="com-codics-ui-mydialog-xxbb-body-header-close iconfonts" @click.stop="changeShow">
                        &#xe84a;</div>
                </div>
                <div class="com-codics-ui-mydialog-xxbb-body-content">
                    <slot></slot>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        height: {
            type: String,
            default: 'fit-content'
        },
        width: {
            type: String,
            default: '450px'
        },
        title: {
            type: String,
            default: '新建窗口'
        },
        out: {
            type: Boolean,
            default: true
        },
        close: {
            type: Function,
            default: () => { }
        }
    },
    data() {
        return {
            nowTime: 0,
        }
    },
    mounted() {
        document.body.appendChild(this.$el); // 将弹窗移出父组件
    },
    beforeDestroy() {
        if (this.$el.parentNode) {
            this.$el.parentNode.removeChild(this.$el);
        }
    },
    watch: {
        visible(newVal) {
            if (!newVal) {
                this.close && this.close();
            }
        }
    },
    methods: {
        changeShow(e) {
            e.stopPropagation();
            if (new Date().getTime() - this.nowTime > 1000) {
                this.nowTime = new Date().getTime();
                // this.$emit('input', !this.value);
                this.$emit('update:visible', !this.visible);
            }
            return false;
        }
    }
}
</script>

<style>
:root {
    --hbb-my-dialog-xxbb-dialog-bg-color: #FFF;
    --hbb-my-dialog-xxbb-dialog-header-add-color: #ea5b18;
    --hbb-my-dialog-xxbb-dialog-font-color: #333;
    --hbb-my-dialog-xxbb-dialog-font-tip-color: #AAA;
    --hbb-my-dialog-xxbb-dialog-l-color: #F0F0F0;
    --hbb-my-dialog-xxbb-dialog-card-bg-color: #FBFAF7;
}

:root[data-theme="dark"] {
    --hbb-my-dialog-xxbb-dialog-bg-color: #303030;
    --hbb-my-dialog-xxbb-dialog-header-add-color: #ea5b18;
    --hbb-my-dialog-xxbb-dialog-font-color: #FFFFFF;
    --hbb-my-dialog-xxbb-dialog-font-tip-color: #555;
    --hbb-my-dialog-xxbb-dialog-l-color: #3A3A3A;
    --hbb-my-dialog-xxbb-dialog-card-bg-color: #404040;
}

/* 弹窗体 */
.com-codics-ui-mydialog-xxbb-body {
    height: 100%;
    width: 100%;
    transition: .3s;
    position: fixed;
    z-index: 2000;
    top: 0;
    left: 0;
    box-sizing: border-box;
    background: rgba(0, 0, 0, 0.6);
    backdrop-filter: blur(3px);
    -webkit-backdrop-filter: blur(3px);
}

.com-codics-ui-mydialog-xxbb-body-card {
    height: fit-content;
    height: var(--height);
    width: 450px;
    width: var(--width);
    position: absolute;
    margin: auto;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #FFF;
    background: var(--hbb-my-dialog-xxbb-dialog-bg-color);
    border-radius: 8px;
    box-sizing: border-box;
    pointer-events: all;
    overflow: hidden;
}

.com-codics-ui-mydialog-xxbb-body-header {
    height: 40px;
    width: 100%;
    position: relative;
    float: left;
    border-bottom: 1px solid #F0F0F0;
    border-bottom: 1px solid var(--hbb-my-dialog-xxbb-dialog-l-color);
    box-sizing: border-box;
    line-height: 40px;
    font-size: 12px !important;
    font-weight: bolder;
    color: #333;
    color: var(--hbb-my-dialog-xxbb-dialog-font-color);
    padding-left: 20px;
    user-select: none;
}

.com-codics-ui-mydialog-xxbb-body-header-add {
    color: var(--hbb-my-dialog-xxbb-dialog-header-add-color);
    font-size: 12px;
}

.com-codics-ui-mydialog-xxbb-body-header-close {
    position: absolute;
    right: 20px;
    top: 0;
    bottom: 0;
    margin: auto;
    font-size: 12px;
    cursor: pointer;
    color: #333;
    color: var(--hbb-my-dialog-xxbb-dialog-font-color);
    user-select: none;
    -webkit-user-drag: none;
}

.com-codics-ui-mydialog-xxbb-body-content {
    height: calc(100% - 40px);
    max-height: 80vh;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 0 20px;
    overflow-x: hidden;
    overflow-y: auto;
}

/* 定义进入和离开的过渡效果 */
.myuidialog-enter-active,
.myuidialog-leave-active {
    transition: .3s;
}

.myuidialog-enter,
.myuidialog-leave-to {
    opacity: 0;
}

.com-codics-ui-mydialog-xxbb-body .el-form-item__label {
    font-size: 12px !important;
}

.com-codics-ui-mydialog-xxbb-body .el-input__inner {
    font-size: 12px !important;
}

@media (max-width:768px) {}
</style>